import type { InsertWebhook, Webhook } from "@/schemas/webhook.schema";
import type { RequestConfig } from "@/services/api";
import { api } from "@/services/api";

export const webhookApi = {
  async create(webhook: InsertWebhook, config?: RequestConfig) {
    const { data } = await api.post("/webhooks", webhook, config);

    return data as Webhook;
  },

  async updateById(id: string, webhook: Partial<InsertWebhook>, config?: RequestConfig) {
    await api.patch(`/webhooks/${id}`, webhook, config);
  },

  async deleteById(id: string, config?: RequestConfig) {
    await api.delete(`/webhooks/${id}`, config);
  },

  async retryEvent(id: string, eventId: string) {
    await api.post(`/webhooks/${id}/events/${eventId}/retry`);
  },
};
